// extracted by mini-css-extract-plugin
module.exports = {"footer":"style-module__footer___1D-WW","loadMoreBtn":"style-module__loadMoreBtn___skFXo"};